"use strict";
/**
 * ErrorHandler helps spot and determine transaction errors.
 *
 * @packageDocumentation
 * @module ErrorHandler
 * @preferred
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtrinsicError = exports.extrinsicSuccessful = exports.extrinsicFailed = exports.SystemEvent = void 0;
const config_1 = require("@kiltprotocol/config");
const ExtrinsicError_1 = require("./ExtrinsicError");
const log = config_1.ConfigService.LoggingFactory.getLogger('Blockchain');
var SystemEvent;
(function (SystemEvent) {
    SystemEvent["ExtrinsicSuccess"] = "0x0000";
    SystemEvent["ExtrinsicFailed"] = "0x0001";
})(SystemEvent = exports.SystemEvent || (exports.SystemEvent = {}));
/**
 * Checks if there is `SystemEvent.ExtrinsicFailed` in the list of
 * transaction events within the given `extrinsicResult`.
 *
 * @param extrinsicResult The result of a submission.
 * @returns Whether the extrinsic submission failed.
 */
function extrinsicFailed(extrinsicResult) {
    const events = extrinsicResult.events || [];
    return events.some((eventRecord) => {
        return (eventRecord.phase.isApplyExtrinsic &&
            eventRecord.event.index.toHex() === SystemEvent.ExtrinsicFailed);
    });
}
exports.extrinsicFailed = extrinsicFailed;
/**
 * Checks if there is `SystemEvent.ExtrinsicSuccess` in the list of
 * transaction events within the given `extrinsicResult`.
 *
 * @param extrinsicResult The result of a submission.
 * @returns Whether the extrinsic submission succeeded.
 */
function extrinsicSuccessful(extrinsicResult) {
    const events = extrinsicResult.events || [];
    return events.some((eventRecord) => {
        return (eventRecord.phase.isApplyExtrinsic &&
            eventRecord.event.index.toHex() === SystemEvent.ExtrinsicSuccess);
    });
}
exports.extrinsicSuccessful = extrinsicSuccessful;
/**
 * Get the extrinsic error from the transaction result.
 *
 * @param extrinsicResult The transaction result.
 * @returns The extrinsic error.
 */
function getExtrinsicError(extrinsicResult) {
    const errorEvent = extrinsicResult.dispatchError;
    if (errorEvent && errorEvent.isModule) {
        const moduleError = errorEvent.asModule;
        const index = moduleError.index.toNumber();
        const error = moduleError.error.toNumber();
        if (index >= 0 && error >= 0) {
            return ExtrinsicError_1.errorForPallet({ index, error });
        }
        log.warn(`error event module index or error code out of range. index: ${index}; error: ${error}`);
    }
    return null;
}
exports.getExtrinsicError = getExtrinsicError;
